export default "__VITE_ASSET__qkHAsQrN__"